export const PROJECTS_DEVICES_FILTER_DEFAULT_OPTION = {
    displayName: "All devices",
    isAvailable: true,
    value: 0
};
